import { miniApps as en_miniApps } from "../en/mini-apps";

/** mini-apps — RU slice (114 keys). */
export const miniApps: Record<keyof typeof en_miniApps, string> = {
  miniapps_close_button: "Закрыть",
  miniapps_close_accessibility_label: "Закрыть мини-приложение",
  miniapps_error_load_failed: "Не удалось загрузить мини-приложение",
  miniapps_error_title: "Ошибка",
  miniapps_success_title: "Готово",
  miniapps_cancel_button: "Отмена",
  miniapps_delete_button: "Удалить",
  miniapps_try_again_button: "Попробовать снова",
  miniapps_go_back_button: "Назад",
  miniapps_loading: "Загрузка...",
  miniapps_demo_title: "Демо мини-приложение",
  miniapps_demo_description:
    "Проверь все возможности моста: данные профиля, хранилище, вызовы API, тосты, уведомления и не только.",
  miniapps_demo_open_button: "Открыть демо",
  miniapps_demo_open_full_button: "Открыть демо мини-приложение",
  miniapps_demo_error_prefix: "Ошибка: {error}",
  miniapps_demo_result_success: "Последний результат: успех",
  miniapps_demo_result_failed: "Последний результат: неудача",
  miniapps_demo_result_with_data: "Последний результат: {status} - {data}",
  miniapps_permission_request_title: "Запрос доступа",
  miniapps_permission_deny_button: "Отклонить",
  miniapps_permission_allow_button: "Разрешить",
  miniapps_permission_grant_fallback: "Выдать доступ: {permission}",
  miniapps_permission_user_read_title: "Чтение профиля",
  miniapps_permission_user_read_description:
    "Доступ к данным твоего профиля, включая имя и фото",
  miniapps_permission_user_write_title: "Изменение профиля",
  miniapps_permission_user_write_description:
    "Внесение изменений в данные твоего профиля",
  miniapps_permission_api_read_title: "Чтение данных",
  miniapps_permission_api_read_description: "Доступ к данным платформы Linqx",
  miniapps_permission_api_write_title: "Запись данных",
  miniapps_permission_api_write_description:
    "Создание и изменение данных на платформе Linqx",
  miniapps_permission_camera_title: "Камера",
  miniapps_permission_camera_description:
    "Съёмка фото и запись видео с помощью твоей камеры",
  miniapps_permission_files_title: "Файлы",
  miniapps_permission_files_description: "Доступ к файлам на твоём устройстве",
  miniapps_permission_notifications_title: "Уведомления",
  miniapps_permission_notifications_description:
    "Отправка тебе push-уведомлений",
  miniapps_permission_location_title: "Геолокация",
  miniapps_permission_location_description:
    "Доступ к местоположению устройства",
  miniapps_permission_storage_title: "Хранилище",
  miniapps_permission_storage_description:
    "Хранение данных локально на твоём устройстве",
  miniapps_permission_haptics_title: "Вибрация",
  miniapps_permission_haptics_description: "Тактильная отдача",
  miniapps_permission_contacts_title: "Контакты",
  miniapps_permission_contacts_description: "Доступ к твоим контактам",
  miniapps_permission_default_label: "Доступ по умолчанию",
  miniapps_permission_optional_label: "Необязательный доступ",
  miniapps_list_title: "Мини-приложения",
  miniapps_list_loading: "Загрузка мини-приложений...",
  miniapps_list_error_title: "Не удалось загрузить мини-приложения",
  miniapps_list_create_button: "Создать",
  miniapps_list_empty_title: "Пока нет мини-приложений",
  miniapps_list_empty_description:
    "Создай своё первое мини-приложение или дождись, пока их добавит администратор.",
  miniapps_list_create_mini_app_button: "Создать мини-приложение",
  miniapps_list_available_apps_title: "Доступные приложения ({count})",
  miniapps_list_no_description: "Без описания",
  miniapps_list_info_text:
    "Мини-приложения — это лёгкие веб-приложения, которые работают внутри Linqx. С твоего разрешения они получают доступ к профилю и интегрируются с возможностями платформы.",
  miniapps_details_loading: "Загрузка данных приложения...",
  miniapps_details_error_title: "Не удалось загрузить приложение",
  miniapps_details_by_developer: "от {developer}",
  miniapps_details_status_active: "Активно",
  miniapps_details_status_system: "Системное",
  miniapps_details_open_app_button: "Открыть приложение",
  miniapps_details_app_info_title: "Информация о приложении",
  miniapps_details_version_label: "Версия",
  miniapps_details_app_id_label: "ID приложения",
  miniapps_details_added_label: "Добавлено",
  miniapps_details_system_app_label: "Системное приложение",
  miniapps_details_system_app_description:
    "Встроенное приложение под управлением Linqx. Доступы выдаются автоматически.",
  miniapps_details_permissions_title: "Доступы",
  miniapps_details_no_permissions: "Этому приложению не нужны особые доступы.",
  miniapps_details_danger_zone_title: "Опасная зона",
  miniapps_details_delete_app_button: "Удалить приложение",
  miniapps_details_cannot_delete_title: "Нельзя удалить",
  miniapps_details_cannot_delete_message:
    "Системные приложения нельзя удалить.",
  miniapps_details_delete_confirm_title: "Удалить мини-приложение",
  miniapps_details_delete_confirm_message:
    "Точно удалить «{appName}»? Это действие нельзя отменить.",
  miniapps_details_error_load: "Не удалось загрузить данные приложения",
  miniapps_ok_button: "OK",
  miniapps_details_permission_update_error: "Не удалось обновить доступ",
  miniapps_details_delete_error: "Не удалось удалить мини-приложение",
  miniapps_create_title: "Создать мини-приложение",
  miniapps_create_subtitle: "Настрой новое мини-приложение",
  miniapps_create_basic_info_title: "Основная информация",
  miniapps_create_app_id_label: "ID приложения",
  miniapps_create_app_id_placeholder: "com.example.myapp",
  miniapps_create_app_id_error_required: "Укажи ID приложения",
  miniapps_create_app_id_error_format:
    "ID приложения должен начинаться с буквы и содержать только строчные буквы, цифры, точки и дефисы",
  miniapps_create_name_label: "Название",
  miniapps_create_name_placeholder: "Моё крутое приложение",
  miniapps_create_name_error_required: "Укажи название",
  miniapps_create_description_label: "Описание",
  miniapps_create_description_placeholder:
    "Опиши, что делает твоё приложение...",
  miniapps_create_url_label: "URL",
  miniapps_create_url_placeholder: "https://example.com/app",
  miniapps_create_url_error_required: "Укажи URL",
  miniapps_create_url_error_format:
    "URL должен начинаться с http://, https:// или data:",
  miniapps_create_icon_label: "Иконка приложения",
  miniapps_create_icon_add: "Добавить",
  miniapps_create_icon_hint:
    "Нажми, чтобы загрузить квадратную иконку (рекомендуем 512x512)",
  miniapps_create_developer_label: "Разработчик",
  miniapps_create_developer_placeholder: "Твоё имя или компания",
  miniapps_create_version_label: "Версия",
  miniapps_create_version_placeholder: "1.0.0",
  miniapps_create_version_error_required: "Укажи версию",
  miniapps_create_permissions_title: "Доступы",
  miniapps_create_permissions_description:
    "Выбери, какие доступы нужны приложению. Доступы по умолчанию выдаются автоматически.",
  miniapps_create_enable_label: "Включить",
  miniapps_create_default_label: "По умолчанию",
  miniapps_create_cancel_button: "Отмена",
  miniapps_create_creating: "Создаём...",
  miniapps_create_submit_button: "Создать приложение",
  miniapps_create_success_title: "Готово",
  miniapps_create_success_message: "Мини-приложение создано",
  miniapps_create_error: "Не удалось создать мини-приложение",
};
